// extracted by mini-css-extract-plugin
export default {"linksWrapper":"BlueLink_linksWrapper__So49i","link":"BlueLink_link__I04w+","linkto":"BlueLink_linkto__NhSpg","arrow":"BlueLink_arrow__0RXfU","brighter":"BlueLink_brighter__N9GSu"};